import {
  apiFrontendServiceLandingLocaleRetrieve,
  getApiFrontendServiceLandingLocaleRetrieveQueryKey,
  useApiFrontendServiceLandingLocaleRetrieve,
} from '@rover/rsdk/src/apiClient/latest/api-frontend-service-landing-locale-retrieve';
import type { LocalizedBrandService } from '@rover/rsdk/src/apiClient/latest/model/localizedBrandService';
import { type CountryUrlPrefix } from '@rover/utilities/roverGeo.constants';

export interface ServiceLandingPathDescriptor {
  countryUrlPrefix: CountryUrlPrefix;
  serviceLandingSlug: string;
  language: string;
}

export function getServiceLandingFetchArgs(descriptor: ServiceLandingPathDescriptor): {
  queryKey: ReturnType<typeof getApiFrontendServiceLandingLocaleRetrieveQueryKey>;
  queryFn: () => ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>;
} {
  const { countryUrlPrefix, serviceLandingSlug, language } = descriptor;
  return {
    queryKey: getApiFrontendServiceLandingLocaleRetrieveQueryKey(
      countryUrlPrefix,
      language,
      serviceLandingSlug
    ),
    queryFn: () =>
      apiFrontendServiceLandingLocaleRetrieve(countryUrlPrefix, language, serviceLandingSlug),
  };
}

const useServiceLanding = (
  descriptor: ServiceLandingPathDescriptor
): ReturnType<typeof useApiFrontendServiceLandingLocaleRetrieve<LocalizedBrandService>> => {
  const { countryUrlPrefix, serviceLandingSlug, language } = descriptor;
  return useApiFrontendServiceLandingLocaleRetrieve(countryUrlPrefix, language, serviceLandingSlug);
};

export default useServiceLanding;
